<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>
    <div class="cloud_top_banners">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="trinka_cloud_banner_text">
                        <span>Dicionário pessoal</span>
                        <h1>Customize Trinka com seu próprio dicionário</h1>
                        <p>Evite alertas de ortografia para novos termos com seu próprio dicionário. Basta adicionar palavras
                            que Trinka ainda não conhece, como nomes de marcas ou novas técnicas, e Trinka as lembrará onde
                            quer que você escreva.</p>
                        <a href="https://cloud.trinka.ai/signup?_rg=PT" id="autoEditGetStart" target="_blank">Iniciar</a>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="trinka_cloud_banner_img">
                        <img src="../../../assets/images/Personal-Dictionary.png" alt="Personal Dictionary">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="SectionHowItWrok">
        <div class="container">
            <div class="row">
                <div class="col-xl-6">
                    <div class="ImgSectionHowItWrok">
                        <a href="" data-toggle="modal" data-target="#wordPluginPopup" id="VewiVideoSection">
                            <img src=".././../../assets/images/MyDicitonayThumbnail.png" alt="dictionary thumbnail" class="img-fluid eposter-img">
                        </a>
                    </div>
                </div>
                <div class="col-xl-6">
                    <div class="contentSectionHowItWrok">
                        <h2>Veja como funciona</h2>
                        <div class="HeadingSubLine"></div>
                        <p style="margin-bottom: 10px;">Confira o vídeo passo a passo fácil para começar a construir seu Dicionário Pessoal rapidamente.</p>
                        <p style="margin-bottom: 10px;">É um tutorial passo a passo detalhado para ajudá-lo a usar Trinka ao máximo. Tem mais perguntas?
                            Navegue pelas nossas perguntas frequentes
                            <a style="color: #0000ff;" (click)="scroll(target)" class="link">aqui</a>.</p>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <div class="keyFeatureSection">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <h2>Recuros-chave do dicionário pessoal do Trinka</h2>
                    <div class="HeadingSubLine"></div>
                    <p style="margin-bottom: 40px;">Livre-se da sinalização desnecessária de palavras e torne sua experiência de escrita perfeita.</p>
                </div>
            </div>
        </div>
    </div>

    <div class="writeToolboxs_section">
        <div class="writeToolbox_inner_sections" style="background-image: url('../../../assets/images/toolbox_backgrond_browser_plugin_r.png');">
            <div class="container">
                <div class="row">
                    <div class="col-lg-5">
                        <div class="toolbox_img_content">
                            <img src="../../../assets/images/correct-spelling.png" alt="correct spelling" class="img-fluid">
                        </div>
                    </div>
                    <div class="col-lg-7">
                        <div class="toolbox_text_content">
                            <h3>Categorização de palavras</h3>
                            <p>Você pode organizar as palavras que adicionar ao seu dicionário como grafias corretas, nomes
                                de procedimentos técnicos, nomes biológicos, nomes de produtos etc.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="writeToolbox_inner_sections">
            <div class="container">
                <div class="row">
                    <div class="col-lg-7">
                        <div class="toolbox_text_content">
                            <h3>Ajustar a sensibilidade de maiúsculas e minúsculas</h3>
                            <p>Você pode até controlar se o Trinka deve ignorar os termos do seu dicionário quando eles correspondem
                                a maiúsculas ou independentemente.</p>
                        </div>
                    </div>
                    <div class="col-lg-5">
                        <div class="toolbox_img_content">
                            <img src="../../../assets/images/case-sensitive.png" alt="case sensitive" class="img-fluid">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="writeToolbox_inner_sections" style="background-image: url('../../../assets/images/toolbox_backgrond_browser_plugin_r.png');">
            <div class="container">
                <div class="row">
                    <div class="col-lg-5">
                        <div class="toolbox_img_content">
                            <img src="../../../assets/images/american-english.png" alt="american english" class="img-fluid">
                        </div>
                    </div>
                    <div class="col-lg-7">
                        <div class="toolbox_text_content">
                            <h3>Escolha o tipo de Inglês</h3>
                            <p>O Trinka permite controlar se os termos adicionados são ignorados quando o tipo em inglês corresponde
                                ou são ignorados independentemente. </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="writeToolbox_inner_sections">
            <div class="container">
                <div class="row">
                    <div class="col-lg-7">
                        <div class="toolbox_text_content">
                            <h3>Sincronização entre plataformas</h3>
                            <p>Todas as palavras que você adicionou ao seu dicionário são sincronizadas automaticamente em tempo
                                real em todas as plataformas. Seja editor de nuvem, MS Word Add-in ou Browser Plug-in, o
                                seu dicionário Trinka funciona em qualquer lugar.</p>
                        </div>
                    </div>
                    <div class="col-lg-5">
                        <div class="toolbox_img_content noBackgroundColor syncAcrossImages">
                            <img src="../../../assets/images/SyncAcrossPlatforms.png" alt="platforms" class="img-fluid" style="max-width: 300px;">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="writeToolbox_inner_sections" style="background-image: url('../../../assets/images/toolbox_backgrond_browser_plugin_r.png');">
            <div class="container">
                <div class="row">
                    <div class="col-lg-5">
                        <div class="toolbox_img_content noBackgroundColor">
                            <img src="../../../assets/images/MyDictionary_Brand-tone.png" alt="dictionary" class="img-fluid">
                        </div>
                    </div>
                    <div class="col-lg-7">
                        <div class="toolbox_text_content">
                            <h3>Manter o tom da marca
                                <span>empresa</span>
                            </h3>
                            <p>Adicione o léxico da sua organização e novos termos para manter a marca em todas as comunicações
                                e personalize a sua assistência de redação.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div class="cloud_key_features" style="display: none;">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="key_features_heading">
                        <h2>Key Features of Trinka Personal Dictionary</h2>
                        <div class="HeadingSubLine"></div>
                        <p>Get rid of unnecessary word flagging and make your writing experience seamless.
                        </p>
                    </div>
                </div>
            </div>
            <div class="row">

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <img src="../../../assets/images/BuildYourVeryOwnDictionary.png" alt="Build Your Very Own Dictionary">
                        <h3>Build Your Very Own Dictionary</h3>
                        <p>Create your own dictionary by adding terms as you use Trinka or just add them all in one go. You
                            can edit and delete words any time.
                        </p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <img src="../../../assets/images/CategorizationOfWords.png" alt="Categorization of Words">
                        <h3>Categorization of Words</h3>
                        <p>You can organize the words you add to your dictionary as correct spellings, technical procedure names,
                            biological names, product names, etc. Trinka gets better as you do.
                        </p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <img src="../../../assets/images/AdjustCaseSensitivity.png" alt="case Sensitivity">
                        <h3>Adjust Case Sensitivity</h3>
                        <p>You can even control whether Trinka should ignore your dictionary terms when they match casing or
                            regardless.
                        </p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards commingSoonTag">
                        <img src="../../../assets/images/ChooseEnglishType.png" alt="english type">
                        <h3>Choose English Type</h3>
                        <p>Trinka lets you control whether added terms are ignored when the English type matches or are ignored
                            regardless.
                        </p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="features_cards commingSoonTag">
                        <span>Enterprise</span>
                        <img src="../../../assets/images/MaintainBrandTone.png" alt="brand tone">
                        <h3>Manter o Tom da Marca</h3>
                        <p>Adicione o léxico da sua organização e novos termos para manter a marca em todas as comunicações
                            e personalize a sua assistência de redação. </p>
                    </div>
                </div>

                <!-- <div class="col-lg-4 col-md-6">
                    <div class="features_cards commingSoonTag">
                        <img src="../../../assets/images/subjectAreaAndDocumentType.svg" alt="subject area">
                        <h3>Advanced Controls</h3>
                        <p>With advanced controls, you can search for words and sort them too based on recent additions and
                            alphabetical order.</p>
                    </div>
                </div> -->

            </div>
        </div>
    </div>

    <div class="forpersonlized_sections">
        <p>Personalize a sua escrita com o dicionário personalizado</p>
        <div class="forpersonlizedFooter">
            <a href="https://cloud.trinka.ai/signup?_rg=PT" target="_blank">Iniciar</a>
        </div>
    </div>

    <div class="pricingQuestionAnwser" #target>
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="pricingHeadingQuestion">
                        <h2>Perguntas feitas frequentemente</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                </div>
                <div class="col-lg-1"></div>
                <div class="col-lg-10">
                    <div class="pricingQuestionsList">
                        <div class="accordion" id="faq">
                            <div class="card">
                                <div class="card-header" id="QuestionOne">
                                    <a href="#" class="btn btn-header-link" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                        Alguém além de mim, pode acessar as palavras que eu adiciono?</a>
                                </div>

                                <div id="QuestionOneContent" class="collapse show" aria-labelledby="QuestionOne" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Seu dicionário pessoal é apenas seu. Ninguém mais pode acessá-lo ou usá-lo.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionTwo">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                        aria-controls="QuestionTwoContent">Onde posso encontrar o meu Dicionário Pessoal? </a>
                                </div>

                                <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                    <div class="card-body">
                                        <!-- <p>In your
                                            <a href="https://cloud.trinka.ai/dashboard/profile" target="_blank">Account Settings</a>. You will see the My Dictionary button within the Writing
                                            Settings section. </p> -->
                                        <p>Nas configurações da sua conta. Você verá o botão Meu Dicionário na seção Configurações
                                            de Escrita.</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionThree">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionThreeContent" aria-expanded="true"
                                        aria-controls="QuestionThreeContent">
                                        Posso compartilhar o meu dicionário com outra conta?
                                    </a>
                                </div>

                                <div id="QuestionThreeContent" class="collapse" aria-labelledby="QuestionThree" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Seu dicionário é apenas seu e não pode ser compartilhado com outra conta. </p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionFour">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                        aria-controls="QuestionFourContent">
                                        Posso baixar meu Dicionário Pessoal?
                                    </a>
                                </div>

                                <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Atualmente, você não pode baixar o seu dicionário. Entretanto, iremos adicionar este
                                            recurso em breve.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="card">
                                <div class="card-header" id="QuestionFive">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFiveContent" aria-expanded="true"
                                        aria-controls="QuestionFiveContent">
                                        Customize Trinka com o seu Dicionário Pessoal
                                    </a>
                                </div>

                                <div id="QuestionFiveContent" class="collapse" aria-labelledby="QuestionFive" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Adicione palavras ao seu Dicionário Pessoal que o Trinka não reconhece, como nomes
                                            de marcas ou novas técnicas para evitar alertas de ortografia.
                                        </p>
                                    </div>
                                </div>
                            </div> -->
                        </div>
                    </div>
                </div>
                <div class="col-lg-1"></div>
            </div>
        </div>
    </div>
    <div class="use_trinka_other_app">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="use_trinka_content">
                        <div class="use_trinka_heading">
                            <div class="howItWorkHeading lineWhiteColor">
                                <h2>Use o Trinka em outros aplicativos</h2>
                                <div class="HeadingSubLine"></div>
                            </div>
                        </div>
                        <div class="others_app_name">
                            <ul>
                                <li>
                                    <a href="https://www.trinka.ai/pt/trinkacloud">
                                        <div class="app_name_content" routerLink="/trinkacloud">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/Other_apps_TrinkaCloud.svg" alt="trinka cloud">
                                            <h3>Trinka Cloud</h3>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.trinka.ai/pt/wordplugin">
                                        <div class="app_name_content" routerLink="">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/Others_App_MSWord.svg" alt="ms word">
                                            <h3>MS Word Plug-in</h3>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.trinka.ai/pt/browser-plugin">
                                        <div class="app_name_content" routerLink="/browser-plugin">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/other_Apps_browser.svg" alt="bowser plugin">
                                            <h3>Plugins do navegador</h3>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.trinka.ai/pt/enterprise">
                                        <div class="app_name_content" style="padding: 0px;" routerLink="/enterprise">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/Other_Apps_enterprise.svg" alt="enterprise">
                                            <h3 style="margin: 0 0 -2px 0;">Empresas</h3>
                                            <span style="font-size: 9px; color: #000; position: relative;">(API, JS & On-Premise)
                                            </span>
                                        </div>
                                    </a>
                                </li>

                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Modal -->
<div class="modal fade" id="wordPluginPopup" tabindex="-1" role="dialog" aria-labelledby="wordPluginLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-body" style="padding: 0;">
                <button type="button" id="closedPopup" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div id="iframeHolder"></div>

                <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/5KsBh4PQUPI"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                <!-- <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/z-TVcRwVp3A"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe> -->
            </div>
        </div>
    </div>
</div>